import { mapGetters } from 'vuex';
import { HttpGetPriceTemplate, HttpGetAllTemplate } from '@/service/tasks';
import { HttpServiceWarehouseList } from "@/service/basicdata"
import {
    HttpGetBillingUnit,
    HttpGetAllBillingCondition,
    HttpGetOurWarehouseList
} from '@/service/bespeak';
export default {
	data() {
        return {
            workListPay: [],
            storageListPay: [],
            addedListPay: [],
            workListReceive: [],
            storageListReceive: [],
            addedListReceive: [],
            warehouseList: [],  //系统仓
            billUnitEnum:[],
            billConditionEnum:[],
            allTemplate: [],
            warehouseListChange: [], //3.8修改
        }
    },
    created(){
        // 3.8修改
        HttpGetOurWarehouseList().then(res => {
            this.warehouseListChange = (res.data || []).map(item => {
                return {
                    value: item.code,
                    label: `${item.code}(${item.title})`,
                    attach: {...item}
                }
            });
        }, err => {
            this.$Message.error({
                content: err.message,
                duration: 30,
                closable: true
            });
        });
        // 查询计费单位与附加条件
        HttpGetBillingUnit().then(res=>{
            Object.keys(res.data).forEach((key)=>{
                let jsonone = {
                    label:key,
                    value:res.data[key]
                }
                this.billUnitEnum.push(jsonone)
            })
        })
        HttpGetAllBillingCondition().then(res=>{
            this.billConditionEnum = res.data.map(item=>{
                return {
                    value:item.code,
                    label:item.name
                }
            })
        })
        HttpServiceWarehouseList().then(res => {
            this.warehouseList = (res.data || []).map(item => {
                return {
                    value: item.code,
                    label: `${item.code}(${item.title})`,
                    attach: item
                }
            });
        }, err => {
            this.$VMessage.error(err.message);
        });
        HttpGetPriceTemplate({expenseCategoryType: 0, billChannel: 1}).then(res=>{
            this.workListPay = res.data
        });
        HttpGetPriceTemplate({expenseCategoryType: 1, billChannel: 1}).then(res=>{
            this.storageListPay = res.data
        });
        HttpGetPriceTemplate({expenseCategoryType: 3, billChannel: 1}).then(res=>{
            this.addedListPay = res.data
        });
        HttpGetPriceTemplate({expenseCategoryType: 0, billChannel: 0}).then(res=>{
            this.workListReceive = res.data
        });
        HttpGetPriceTemplate({expenseCategoryType: 1, billChannel: 0}).then(res=>{
            this.storageListReceive = res.data
        });
        HttpGetPriceTemplate({expenseCategoryType: 3, billChannel: 0}).then(res=>{
            this.addedListReceive = res.data
        });
        HttpGetAllTemplate().then(res=>{
            this.allTemplate = res.data
        });
    },
    computed: {
        ...mapGetters('dictionary', ['getTransferHostWarehouse']),
        warehouseListInvalid(){
            return this.getTransferHostWarehouse.map(item=>{
                return {value: item.attach.code, label: item.label}
            })
        },
        getOrderList(){
            return [
                { value: 200, label: 'B2C销售出库' },
                { value: 400, label: '销售退货单' },
                { value: 401, label: '销售退货单-销毁' },
                { value: 410, label: '销售退货计划单' },
                { value: 417, label: '退货处理单-销毁' },
                { value: 418, label: '退货处理单-换标' },
                { value: 430, label: '入库单' },
                { value: 431, label: '无来源入库单' },
                { value: 330, label: '调拨入库单' },
                { value: 310, label: '调拨出库单' },
                { value: 130, label: '中转入库单' },
                { value: 120, label: '中转出库单' },
                { value: 100, label: '中转入库计划' },
                { value: 6001, label: '销毁单' },
                { value: 202, label: 'B2C-卡车' },
                { value: 203, label: 'B2C-卡车PO' },
                { value: 204, label: 'B2C-快递PO' },
                { value: 299, label: '拦截单-B2C' },
                { value: 2991, label: '拦截单-B2C卡车' },
                { value: 2992, label: '拦截单-B2C卡车PO' },
                { value: 2993, label: '拦截单-B2C快递PO' },
                { value: 420, label: '入库计划单' },
                { value: 490, label: '认领处理单' },
                { value: 491, label: '认领处理单-销毁' },
            ]
        },
        getLogActions () {
            return {
                4: this.$t('fbb.inbound.common_tracking_to_boss', { defaultValue: 'tracking回写Boss' }),
                10: this.$t('fbb.inbound.common_push_attachment', { defaultValue: '推送附件' }),
                13: this.$t('fbb.inbound.common_stock_rewrite', { defaultValue: '库存流水回写' }),
                90: this.$t('fbb.inbound.common_lose_efficacy', { defaultValue: '失效' }),
                96: this.$t('fbb.inbound.common_fba_data_import', { defaultValue: 'FBA箱数据导入' }),
                100: this.$t('global.common.create', { defaultValue: '创建' }),
                150: this.$t('fbb.inbound.add_remark', { defaultValue: '添加备注' }),
                200: this.$t('fbb.inbound.common_update', { defaultValue: '更新' }),
                210: this.$t('global.common.operation_submit', { defaultValue: '提交' }),
                220: this.$t('fbb.inbound.common_shipping', { defaultValue: '发运' }),
                230: this.$t('fbb.inbound.common_save_and_commit', { defaultValue: '保存并提交' }),
                240: this.$t('fbb.inbound.common_widthdraw_reply', { defaultValue: '撤回申请' }),
                250: this.$t('global.common.save', { defaultValue: '保存' }),
                260: this.$t('global.common.edit', { defaultValue: '编辑' }),
                290: this.$t('fbb.inbound.common_unloading', { defaultValue: '卸货' }),
                300: this.$t('global.common.delete', { defaultValue: '删除' }),
                400: this.$t('global.common.cancel', { defaultValue: '取消' }),
                500: this.$t('fbb.inbound.pass_audit', { defaultValue: "审核通过" }),
                560: this.$t('fbb.inbound.cancel_audit', { defaultValue: '撤销审核' }),
                600: this.$t('fbb.inbound.common_audit_rejection', { defaultValue: '审核拒绝' }),
                610: this.$t('fbb.inbound.common_boss_handle', { defaultValue: 'BOSS处理' }),
                620: this.$t('fbb.inbound.common_file_export', { defaultValue: '文件导出' }),
                700: this.$t('fbb.inbound.audit', { defaultValue: '审核' }),
                710: this.$t('fbb.inbound.common_outbound', { defaultValue: '已出库' }),
                720: this.$t('global.common.confirmed', { defaultValue: '已确认' }),
                800: this.$t('global.common.finish', { defaultValue: '完成' }),
                830: this.$t('fbb.inbound.rawcrates_standard', { defaultValue: '生成箱标' }),
                840: this.$t('fbb.inbound.common_operate_change_warehouse', { defaultValue: '换仓操作' }),
                930: this.$t('fbb.inbound.common_push_warehouse', { defaultValue: '推送仓库' }),
                1010: this.$t('fbb.inbound.common_notice_boss', { defaultValue: '调拨入库执行单回传boss' }),
                1020: this.$t('fbb.inbound.click_packing', { defaultValue: '一键装箱' }),
                1030: this.$t('fbb.inbound.confirm_delivery', { defaultValue: '确认发货' }),
                1031: this.$t('fbb.inbound.modify_shipping_information', { defaultValue: '修改发运信息' }),
                1040: this.$t('fbb.inbound.common_purchase_notice', { defaultValue: '采购入库执行单回传' }),
                1046: this.$t('fbb.inbound.common_confirm_reach_warehouse', { defaultValue: '确认到仓' }),
                1050: this.$t('fbb.inbound.common_confirm_push_boss', { defaultValue: '发运确认推送boss' }),
                1060: this.$t('fbb.inbound.common_audit_push_boss', { defaultValue: '审核通过推送boss' }),
                1070: this.$t('fbb.inbound.common_refuse_push_boss', { defaultValue: '审核退回推送boss' }),
                1047: this.$t('fbb.inbound.port_confirm', { defaultValue: '到港确认' }),
                1073:this.$t('fbb.inbound.common_warehouse_rewrite', { defaultValue: '仓库回写' }),
                1090:this.$t('fbb.headlogistics.shangchuanfapiao', { defaultValue: '上传发票' })
            }
        },
        options() {
            return {
                shortcuts: [
                    {text: this.$t("global.common.latest_week",{defaultValue:'最近一周'}),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        }
                    },
                    {text: this.$t("global.common.recent_month",{defaultValue:'最近一月'}),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        }
                    },
                    {text: this.$t("global.common.latest_quarter",{defaultValue:'最近一季度'}),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        }
                    }
                ]
            }
        },

        // 计费模式
        billMode(){
            return [
                { value: 200, label: 'SKU批次' },
                { value: 201, label: 'SKU批次+入库时间' },
                { value: 11111, label: '代码' },
                { value: 22222, label: '规则引擎' },
            ]
        },
        // 库存类型
        invenType(){
            return [
                { value: '500', label: '所有' },
                { value: '501', label: '可售' },
                { value: '502', label: '不可售' },
            ]
        }
    }
}
